<template>
<div class="pb-10">
    <div class="mb-4 flex flex-col gap-y-2 sm:flex-row justify-between">
        <h2 class="text-xl font-bold">リンクカード</h2>
        <a href="https://support.livedoor.info/hc/ja/articles/17458756546319" class="flex items-center link-styles space-x-1 self-end" target="_blank" rel="noopener noreferrer">
            <i class="fa-regular fa-circle-question"></i>
            <span>リンクカードとは</span>
        </a>
    </div>

    <!-- カード未登録時 -->
    <div
        v-if="!linkCard"
        class="flex items-center justify-between bg-base rounded-sm p-4"
    >
        <span class="text-sub text-sm">カードがありません</span>
        <button class="btn-secondary bg-white text-sm" @click="openEditModal(null)">カードを追加</button>
    </div>

    <!-- カード登録済み時 -->
    <div
        v-else
        class="flex items-center justify-between bg-gray-100 rounded-sm p-3 gap-2"
    >
        <span class="flex-1 min-w-0 break-words">{{ linkCard.title }}</span>
        <div class="flex items-center space-x-2 shrink-0">
            <button class="btn-secondary bg-white text-sm" @click="openEditModal(linkCard)">編集</button>
            <button class="text-alert text-xl" @click="confirmDelete" :disabled="isDeleting">
                <i class="fa-light fa-xmark" title="削除"></i>
            </button>
        </div>
    </div>

    <!-- 編集モーダル -->
    <LinkCardEditModal
        :visible="isEditModalOpen"
        :article-id="articleId"
        :edit-data="editData"
        @close="isEditModalOpen = false"
        @saved="onCardSaved"
    />
</div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import LinkCardEditModal from './LinkCardEditModal.vue';

const props = defineProps({
    linkCard: {
        type: Object,
        default: null,
    },
    articleId: {
        type: [Number, String],
        required: true,
    },
});

const emit = defineEmits(['card-saved', 'card-deleted']);

const store = useStore();
const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;

const isEditModalOpen = ref(false);
const isDeleting = ref(false);
const editData = ref(null);

const openEditModal = (cardData) => {
    editData.value = cardData;
    isEditModalOpen.value = true;
};

const onCardSaved = (card) => {
    isEditModalOpen.value = false;
    emit('card-saved', card);
};

const confirmDelete = async () => {
    if (!confirm('リンクカードを削除しますか？')) return;

    isDeleting.value = true;
    try {
        const accessToken = store.state.accessToken;
        await axios.delete(
            `${apiEndpoint}/articles/${props.articleId}/link-cards/${props.linkCard.id}/`,
            {
                headers: { Authorization: `Bearer ${accessToken}` },
            }
        );
        emit('card-deleted');
    } catch (error) {
        console.error('リンクカード削除に失敗しました:', error);
        alert('リンクカードの削除に失敗しました。');
    } finally {
        isDeleting.value = false;
    }
};
</script>
